import styled from "styled-components";

export const Container = styled.div`
  margin-top: 30px;
  width: 90%;
  margin-left: 5%;
  margin-bottom: 100px;
  padding-left:250px;
  & > select {
    margin: 0 16px 16px 0;
  }

  & > a {
    margin: 0 16px 16px 0;
  }
`;
